















import { mapActions } from 'vuex'
import InventoryOverlay from '@/components/InventoryOverlay.vue'
import Notebook from '@/components/Notebook.vue'

export default {
  components: {
    InventoryOverlay,
    Notebook,
  },
  data() {
    return {
      showInventory: false,
      showNotebook: false,
    }
  },
  mounted() {
    document.addEventListener('pickUp', this.handlePickUp)
    document.addEventListener('removeItem', this.handleRemove)
    document.addEventListener('consume', this.handleConsume)
  },
  beforeDestroy() {
    document.removeEventListener('pickUp', this.handlePickUp)
    document.removeEventListener('removeItem', this.handleRemove)
  },
  methods: {
    ...mapActions([
      'addToInventory',
      'removeFromInventory',
      'consume',
      'pauseScene',
      'resumeScene',
    ]),
    openNotebook() {
      this.showNotebook = true
      this.pauseScene()
    },
    closeNotebook() {
      this.showNotebook = false
      this.resumeScene()
    },
    buzz() {
      this.$refs.notebook.classList.add('btn--buzz')
      setTimeout(() => {
        this.$refs.notebook.classList.remove('btn--buzz')
      }, 1000)
    },
    openInventory() {
      this.showInventory = true
      this.pauseScene()
    },
    closeInventory() {
      this.showInventory = false
      this.resumeScene()
    },
    handlePickUp({ detail }) {
      this.addToInventory(detail).then((isNote) => {
        if (isNote) {
          this.buzz()
        }
      })
    },
    handleRemove({ detail }) {
      this.removeFromInventory(detail.id)
    },
    handleConsume({ detail }) {
      this.consume(detail.id)
    },
  },
}
